module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(!_vm.getProfileHaveClient) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Юридический ассистент служба автоматизации рутиных юридических оппераций.")])]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        Для использования Юридического ассистента, необходимо определить Юридическое лицо которое Вы представляете.\n        Регистрируйтесь и направляйте запросы для подготовки Юридических документов: претензий ...\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "to": "/register"
    }
  }, [_vm._v("Регистрация")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getProfileHaveClient && !_vm.$route.params.matterId) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('v-assist-set')], 1) : _vm._e(), _vm._v(" "), (_vm.getProfileHaveClient && _vm.$route.params.matterId) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('v-assist-page', {
    attrs: {
      "itemId": _vm.$route.params.matterId
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55feb066","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/assist/AssistPanel.vue
// module id = 1170
// module chunks = 1